import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { KeycloakTokenParsed } from 'keycloak-js';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  readonly AUTH_CLIENT: string = 'mirempet';
  urlGo = environment.apiGoUrl;

  constructor(private http: HttpClient) {}

  consultarBi(bi: string): Observable<any> {
    const baseUrl = (
      environment.apiProfissionaisUrl ||
      environment.apiUrl ||
      ''
    ).replace(/\/$/, '');
    return this.http.get(`${baseUrl}/profissionais/bi/consultar?bi=${bi}`);
  }

  getInfoByDocument(documentNumber: string): Observable<any> {
    return this.http.get(
      `${this.urlGo}/findDocument?documentNumber=${documentNumber}`,
    );
  }

  getInfoByNif(nif: string): Observable<any> {
    return this.consultarBi(nif);
  }

  userHasRole(token: KeycloakTokenParsed, roles: string[]): boolean {
    let hasRole = false;
    if (token.resource_access && token.resource_access[this.AUTH_CLIENT]) {
      let tokenRoles = token.resource_access[this.AUTH_CLIENT].roles;
      hasRole = roles.every((role) => tokenRoles.includes(role));
    }
    return hasRole;
  }
}
